import { render, staticRenderFns } from "./VgViewFieldList.vue?vue&type=template&id=32ecc44d&scoped=true&"
import script from "./VgViewFieldList.vue?vue&type=script&lang=js&"
export * from "./VgViewFieldList.vue?vue&type=script&lang=js&"
import style0 from "./VgViewFieldList.vue?vue&type=style&index=0&id=32ecc44d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ecc44d",
  null
  
)

export default component.exports